var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$slots.layout)?[_vm._t("layout")]:[_c('dashboard-layout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('AppHeader')]},proxy:true}])})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }